import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { Enums } from '../../../shared/enums';
import { IMPORTS } from './_imports';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'app-header-edocs',
    templateUrl: './header-edocs.component.html',
    styleUrl: './header-edocs.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class HeaderEDocsComponent implements OnInit {
    // #region [Type props]
    Enums = Enums;
    Utils = Utils;
    // #endregion

    // #region [props]
    env: string;
    resolvedSubdomain: string;
    // #endregion

    constructor(
        private cookieService: CookieService,
        private titleService: Title
    ) {
        this.env = atob(this.cookieService.get('prodest-eflow-env')).toLowerCase();
        switch (this.env) {
            case 'loc':
                setTimeout(() => this.titleService.setTitle(`${this.titleService.getTitle()} [L]`), 100);
                break;

            case 'des':
                setTimeout(() => this.titleService.setTitle(`${this.titleService.getTitle()} [D]`), 100);
                break;

            case 'hom':
                setTimeout(() => this.titleService.setTitle(`${this.titleService.getTitle()} [H]`), 100);
                break;

            case 'tre':
                setTimeout(() => this.titleService.setTitle(`${this.titleService.getTitle()} [T]`), 100);
                break;
        }

        this.resolvedSubdomain = Utils.getResolvedEDocsSubdomain(this.cookieService);
    }

    ngOnInit() { }

    shouldHideEnvironment(): boolean {
        return this.env.toLowerCase() == 'prd';
    }

    // #region [===== private methods =====]
    // #endregion
}
